/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IPlacementsConfiguration } from "@almamedia/amr-adtech-stack/lib/services/ads/adsservice";
import { ICustomVariables } from "../data-layer/data-layer";
import { SiteNativeTemplate } from "../native/native";
import {
  blogitCenterParade,
  closeILInterstitial,
  ilParade,
  outstreamStyles,
} from "./custom-needs/custom-needs";
import {
  smokeScreenStyles,
  wallpaperStyles,
} from "./custom-needs/custom-styles";
import { fbOrSquareBlue } from "./helpers/native";

const tiviPlacements: IPlacementsConfiguration<
  ICustomVariables,
  SiteNativeTemplate
> = {
  etusivu_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9797648,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_etusivu_300x300_ylä_mobile",
      lazyload: { offset: { top: 100, bottom: 30 } },
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9797647,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_etusivu_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9797645,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_etusivu_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796807,
      sizes: [[1, 1]],
      friendlyName:
        "Iltalehti.fi_etusivu_300x125|300x250_2_(palstaboksi) - rightBox2",
      adType: ["banner", "native"],
      native: {
        template: "native_rectangle_black_small",
      },
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-widerectangle-6",
      placementId: 12245961,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_etusivu_300x300_supermarket_mobile",
    },
  ],
  uutiset_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9796052,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      lazyload: { disable: true },
      friendlyName: "Iltalehti.fi_uutiset_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Uutiset_ROS_MediumRectangle_Mobile_Top",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9796051,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_uutiset_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Uutiset_ROS_MediumRectangle_Mobile_Mid",
      },
      lazyload: { offset: { top: -75, bottom: 30 } },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9796045,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],

      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_uutiset_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: -75, bottom: 30 } },
    },
    {
      divId: "almad-widerectangle-6",
      placementId: 12245961,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_etusivu_300x300_supermarket_mobile",
    },
  ],
  uutiset_mobile_article: {
    source: "uutiset_mobile",
    remove: ["almad-parade-7", "almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796048,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_uutiset_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Uutiset_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764089,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_uutiset_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Uutiset_ROS_MediumRectangle_Mobile_Top",
        },
        lazyload: { offset: { top: -75, bottom: 30 } },
      },
    ],
  },
  uutiset_mobile_article_sponsored: {
    source: "uutiset_mobile",
    remove: ["almad-parade-7"],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  raha_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 16817065,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      lazyload: { disable: true },
      friendlyName: "Iltalehti.fi_raha_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Raha_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 16817064,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_raha_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Raha_ROS_MediumRectangle_Mobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 16817058,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_raha_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  raha_mobile_article: {
    source: "raha_mobile",
    remove: ["almad-parade-7", "almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 16817060,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_raha_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Raha_Artikkeli_ROS_MediumRectangleMobile",
        },
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764155,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_raha_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Raha_ROS_MediumRectangle_Mobile",
        },
        lazyload: { offset: { top: 40, bottom: 30 } },
      },
    ],
  },
  raha_mobile_article_sponsored: {
    source: "raha_mobile",
    remove: ["almad-parade-7"],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  urheilu_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9796043,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_urheilu_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Urheilu_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9796041,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName: "Iltalehti.fi_urheilu_300x300_keski_mobile",
      native: {
        templateSelector: fbOrSquareBlue,
      },
      prebid: {
        active: !0,
        source: "Iltalehti_Urheilu_ROS_MediumRectangle_Mobile",
      },
      lazyload: { offset: { top: -30, bottom: 30 } },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9796036,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_urheilu_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: -30, bottom: 30 } },
    },
  ],
  urheilu_mobile_article: {
    source: "urheilu_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796038,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_urheilu_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Urheilu_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764051,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_urheilu_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Urheilu_ROS_MediumRectangle_Mobile",
        },
        lazyload: { offset: { top: -30, bottom: 30 } },
      },
    ],
  },
  urheilu_mobile_article_sponsored: {
    source: "urheilu_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  viihde_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9796057,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_viihde_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Viihde_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9796056,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_viihde_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Viihde_ROS_MediumRectangle_Mobile",
      },
      lazyload: { offset: { top: -150, bottom: 30 } },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9796054,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_viihde_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: -150, bottom: 30 } },
    },
  ],
  viihde_mobile_article: {
    source: "viihde_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796055,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_viihde_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Viihde_Artikkeli_ROS_MediumRectangleMobile",
          rubicon: {
            params: {
              position: "atf",
            },
          },
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764091,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_viihde_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Viihde_ROS_MediumRectangle_Mobile",
        },
        lazyload: { offset: { top: -150, bottom: 30 } },
      },
    ],
  },
  viihde_mobile_article_sponsored: {
    source: "viihde_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  saa_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9795997,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_saa_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Saa_ROS_MediumRectangle_Mobile",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9795996,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
      ],
      friendlyName: "Iltalehti.fi_saa_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Saa_Square_Middle_MobileWeb",
      },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9795995,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
      ],
      friendlyName: "Iltalehti.fi_saa_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  iltv_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9797653,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_iltv_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_ILTV_ROS_MediumRectangle_Mobile",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  iltv_mobile_article: { source: "iltv_mobile" },
  iltv_mobile_article_sponsored: {
    source: "iltv_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  terveys_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9796016,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_terveys_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Terveys_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9796012,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_terveys_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Terveys_ROS_MediumRectangle_Mobile",
      },
      lazyload: { offset: { top: -150, bottom: 30 } },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9796008,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_terveys_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  terveys_mobile_article: {
    source: "terveys_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796010,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_terveys_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Terveys_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764015,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_terveys_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Terveys_ROS_MediumRectangle_Mobile",
        },
        lazyload: { offset: { top: -150, bottom: 30 } },
      },
    ],
  },
  terveys_mobile_article_sponsored: {
    source: "terveys_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  hyvaolo_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9795972,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_hyvaolo_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Hyvaolo_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9795971,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_hyvaolo_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Hyvaolo_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9795969,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_hyvaolo_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  hyvaolo_mobile_article: {
    source: "hyvaolo_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9795970,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_hyvaolo_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Hyvaolo_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764158,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_hyvaolo_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Hyvaolo_ROS_MediumRectangle_Mobile",
        },
      },
    ],
  },
  hyvaolo_mobile_article_sponsored: {
    source: "hyvaolo_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  tyylicom_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9796035,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_tyyli_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Tyyli_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9796028,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_tyyli_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Tyyli_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9796024,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_tyyli_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  tyylicom_mobile_article: {
    source: "tyylicom_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796027,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_tyyli_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Tyyli_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764035,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_tyyli_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Tyyli_ROS_MediumRectangle_Mobile",
        },
      },
    ],
  },
  tyylicom_mobile_article_sponsored: {
    source: "tyylicom_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  asuminen_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9797630,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [2, 1],
      ],
      friendlyName: "Iltalehti.fi_asuminen_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Asuminen_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9797629,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_asuminen_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Asuminen_ROS_MediumRectangle_Mobile",
      },
      lazyload: { offset: { top: -30, bottom: 30 } },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9797627,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_asuminen_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  asuminen_mobile_article: {
    source: "asuminen_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9797628,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_asuminen_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Asuminen_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764149,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },

        friendlyName: "Iltalehti.fi_asuminen_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Asuminen_ROS_MediumRectangle_Mobile",
        },
        lazyload: { offset: { top: -30, bottom: 30 } },
      },
    ],
  },
  asuminen_mobile_article_sponsored: {
    source: "asuminen_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  perhe_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9795982,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_perhe_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Perhe_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9795981,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_perhe_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Perhe_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9795978,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_perhe_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  perhe_mobile_article: {
    source: "perhe_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9795980,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_perhe_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Perhe_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18763392,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_perhe_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Perhe_ROS_MediumRectangle_Mobile",
        },
      },
    ],
  },
  perhe_mobile_article_sponsored: {
    source: "perhe_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  pippuri_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9795987,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_pippuri_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Pippuri_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9795986,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_pippuri_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Pippuri_ROS_MediumRectangle_Mobile",
      },
      lazyload: { offset: { top: -150, bottom: 30 } },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9795984,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_pippuri_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  pippuri_mobile_article: {
    source: "pippuri_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9795985,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_pippuri_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Pippuri_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18763409,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_pippuri_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Pippuri_ROS_MediumRectangle_Mobile",
        },
        lazyload: { offset: { top: -150, bottom: 30 } },
      },
    ],
  },
  pippuri_mobile_article_sponsored: {
    source: "pippuri_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  matkailu_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9795954,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_matkailu_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Matkailu_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9795953,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_matkailu_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Matkailu_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9797656,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_matkailu_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  matkailu_mobile_article: {
    source: "matkailu_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9797657,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_matkailu_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Matkailu_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18763385,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_matkailu_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Matkailu_ROS_MediumRectangle_Mobile",
        },
      },
    ],
  },
  matkailu_mobile_article_sponsored: {
    source: "matkailu_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  autot_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9797634,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_autot_300x300_ylä_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Autot_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9797633,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },

      friendlyName: "Iltalehti.fi_autot_300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Autot_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9797631,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_autot_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  autot_mobile_article: {
    source: "autot_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9797632,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_autot_300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Autot_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764119,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_autot_300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Autot_ROS_MediumRectangle_Mobile",
        },
      },
    ],
  },
  autot_mobile_article_sponsored: {
    source: "autot_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  tyoelama_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9796023,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_työelämä_300x300_ylä_mobile",
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9796021,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
      ],
      friendlyName: "Iltalehti.fi_työelämä_300x300_keski_mobile",
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9796018,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_työelämä_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_ROS_Square_Bottom_MobileWeb",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  tyoelama_mobile_article: {
    source: "tyoelama_mobile",
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796020,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "video"],
        friendlyName: "Iltalehti.fi_työelämä_300x300_artikkeliboksi_mobile",
      },
    ],
  },
  tyoelama_mobile_article_sponsored: {
    source: "tyoelama_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  talous_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9796003,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_talous_300x300_ylä_mobile",
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9796002,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
      ],
      friendlyName: "Iltalehti.fi_talous_300x300_keski_mobile",
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9795998,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_talous_300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_ROS_Square_Bottom_MobileWeb",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  talous_mobile_article: {
    source: "talous_mobile",
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796001,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "video"],
        friendlyName: "Iltalehti.fi_talous_300x300_artikkeliboksi_mobile",
      },
    ],
  },
  talous_mobile_article_sponsored: {
    source: "talous_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  digi_mobile: [
    {
      divId: "almad-mobile-parade-1",
      placementId: 9797643,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [320, 300],
        [2, 1],
      ],
      friendlyName: "Iltalehti.fi_digi__300x300_ylä_mobile",
    },
    {
      divId: "almad-mobile-parade-2",
      placementId: 9797642,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 300],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],

      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName: "Iltalehti.fi_digi__300x300_keski_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Digi_ROS_MediumRectangle_Mobile",
      },
    },
    {
      divId: "almad-mobile-parade-3",
      placementId: 9797640,
      sizes: [
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [320, 300],
        [300, 300],
        [300, 250],
        [300, 150],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName: "Iltalehti.fi_digi__300x300_ala_mobile",
      prebid: {
        active: !0,
        source: "Iltalehti_Alapaikat_ROS_MediumRectangleMobile",
      },
      lazyload: { offset: { top: 40, bottom: 30 } },
    },
  ],
  digi_mobile_article: {
    source: "digi_mobile",
    remove: ["almad-mobile-parade-2"],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9797641,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [320, 300],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName: "Iltalehti.fi_digi__300x300_artikkeliboksi_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Digi_Artikkeli_ROS_MediumRectangleMobile",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18764153,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [320, 300],
          [300, 300],
          [320, 320],
          [320, 300],
          [300, 250],
          [300, 150],
          [1, 1],
        ],
        adType: ["banner", "native"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_digi__300x300_keski_mobile",
        prebid: {
          active: !0,
          source: "Iltalehti_Digi_ROS_MediumRectangle_Mobile",
        },
      },
    ],
  },
  digi_mobile_article_sponsored: {
    source: "digi_mobile",
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
      {
        divId: "almad-widerectangle-4",
        placementId: 9797641,
        sizes: [
          [300, 600],
          [300, 431],
          [320, 431],
          [320, 300],
          [300, 300],
          [320, 320],
          [300, 250],
          [300, 150],
        ],
        friendlyName: "Iltalehti.fi_digi__300x300_artikkeliboksi_mobile",
        native: {
          template: "sima_rectangle",
        },
      },
    ],
  },
  blogit: [
    {
      divId: "almad-parade-1",
      placementId: 9797639,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_blogit__300x300_ylä_mobile",
      customNeeds: {
        adLoaded: () => {
          blogitCenterParade();
        },
      },
    },
  ],
  etusivu_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796817,
      sizes: [
        [980, 400],
        [980, 600],
        [980, 552],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_etusivu_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796792,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_etusivu_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-special-1",
      placementId: 9796785,
      sizes: [
        [956, 586],
        [6, 1],
      ],
      lazyload: { disable: !0 },
      friendlyName: "Iltalehti.fi_etusivu_smokeScreen",
      customNeeds: {
        adLoaded: () => {
          smokeScreenStyles();
          const interstitialContainerE = window.document.getElementById(
            "interstitialContainer"
          );
          if (interstitialContainerE) {
            interstitialContainerE.style.display = "block";
          }
          const smokeScreen1E = window.document.getElementById("smokeScreen1");
          if (smokeScreen1E) {
            smokeScreen1E.style.display = "block";
          }
          const interstitialCloseE = window.document.getElementById(
            "interstitialClose"
          );
          if (interstitialCloseE) {
            interstitialCloseE.style.display = "block";
          }

          // eslint-disable-next-line no-unused-vars
          const adTimeout = window.setTimeout(() => {
            closeILInterstitial();
          }, 15000);
        },
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796790,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_etusivu_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega -hissi) - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_WideSkyscraper",
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796791,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_etusivu_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega -hissi) - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_WideSkyscraper",
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796133,
      sizes: [
        [300, 250],
        [468, 400],
        [610, 877],
        [620, 891],
        [505, 500],
        [505, 656],
        [300, 300],
        [320, 320],
        [4, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_etusivu_300x250|468x400|505x500|505x656_1_etusivu_(boksi,jättiboksi,pid.jättiboksi - middleBox1",
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796134,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_etusivu_300x250|468x400|505x500|505x656_2_etusivu_(boksi,jättiboksi,pid.jättiboksi) - middleBox2",
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796806,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
      ],
      friendlyName:
        "Iltalehti.fi_etusivu_300x125|300x250_1_(palstaboksi) - rightBox1",
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796807,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_rectangle_black_small",
      },
      friendlyName:
        "Iltalehti.fi_etusivu_300x125|300x250_2_(palstaboksi) - rightBox2",
      prebid: {
        active: !0,
        source: "Iltalehti_Etusivu_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-widerectangle-6",
      placementId: 12245959,
      sizes: [
        [505, 400],
        [610, 400],
        [505, 300],
        [505, 500],
      ],
      friendlyName: "Iltalehti.fi_etusivu_505x400|505x300_(supermarket)",
    },
  ],
  etusivu_desktop: {
    source: "etusivu_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  uutiset_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796940,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_uutiset_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Uutiset_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796934,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_uutiset_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796932,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_uutiset_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Uutiset_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796933,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_uutiset_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Uutiset_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796208,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },

      friendlyName:
        "Iltalehti.fi_uutiset_300x250|468x400|505x500|505x656_1_etusivu_(boksi,jättiboksi,pid.jättiboksi  Iltalehti_Uutiset_Desktop - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Uutiset_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291837,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_uutiset_outstream_desktop",
      ...outstreamStyles
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796209,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_uutiset_300x250|468x400|505x500|505x656_2_etusivu_(boksi,jättiboksi,pid.jättiboksi - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796935,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_uutiset_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Uutiset_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796936,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_uutiset_300x250_2_(palstaboksi luetuimmat-noston alapuolella - rightBox2)",
      prebid: {
        active: !0,
        source: "Iltalehti_Uutiset_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-widerectangle-6",
      placementId: 12245959,
      sizes: [
        [505, 400],
        [610, 400],
        [505, 300],
        [505, 500],
      ],
      friendlyName: "Iltalehti.fi_etusivu_505x400|505x300_(supermarket)",
    },
  ],
  uutiset_desktop: {
    source: "uutiset_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  uutiset_desktop_article: {
    source: "uutiset_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796939,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        friendlyName:
          "Iltalehti.fi_uutiset_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Uutiset_ROS_MediumRectangle",
        },
        native: {
          template: "sima_rectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281239,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_uutiset_native_artikkeli_ala",
      },
    ],
  },
  uutiset_desktop_article_sponsored: {
    source: "uutiset_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-widerectangle-5",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  uutiset_desktop_wide_article: {
    source: "uutiset_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-widerectangle-5",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796939,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        friendlyName:
          "Iltaleht i.fi_uutiset_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Uutiset_ROS_MediumRectangle",
        },
        native: {
          template: "sima_rectangle",
        },
        ...outstreamStyles,
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281239,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_uutiset_native_artikkeli_ala",
      },
    ],
  },
  uutiset_desktop_wide_article_sponsored: {
    source: "uutiset_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-widerectangle-5",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  "tyoelama-talous_desktop_wide": [
    {
      divId: "almad-parade-1",
      placementId: 9796921,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_työelämä&talous_980x120|980x400_(panorama,paraati) - topBanner",
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796915,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_työelämä&talous_1600x1200_(dynaaminen tapetti) - wallpaper",

      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796197,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_työelämä&talous_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper1",
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796198,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_työelämä&talous_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper2",
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796202,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 1],
      ],
      friendlyName:
        "Iltalehti.fi_työelämä&talous_300x250|468x400|505x500|505x656_1_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
    },
    {
      divId: "almad-outstream-1",
      placementId: 11308505,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_tyoelama&talous_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796203,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_työelämä&talous_300x250|468x400|505x500|505x656_2_etusivu_(boksi,jättiboksi,pid.j - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796916,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 2],
      ],
      friendlyName:
        "Iltalehti.fi_työelämä&talous_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796918,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_työelämä&talous_300x250_2_(palstaboksi luetuimmat-noston alapuolella - rightBox2)",
    },
  ],
  "tyoelama-talous_desktop": {
    source: "tyoelama-talous_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  "tyoelama-talous_desktop_article": {
    source: "tyoelama-talous_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796920,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "video"],
        friendlyName:
          "Iltalehti.fi_työelämä&talous_300x250|468x400_(artikkeliboksi,-jttiboksi)",
      },
    ],
  },
  "tyoelama-talous_desktop_article_sponsored": {
    source: "tyoelama-talous_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  "tyoelama-talous_desktop_wide_article": {
    source: "tyoelama-talous_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796920,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "video"],
        friendlyName:
          "Iltalehti.fi_työelämä&talous_300x250|468x400_(artikkeliboksi,-jttiboksi)",
      },
    ],
  },
  "tyoelama-talous_desktop_wide_article_sponsored": {
    source: "tyoelama-talous_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  raha_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 16817115,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_raha_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Raha_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 16817084,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_raha_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 16817081,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_raha_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Raha_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 16817083,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_raha_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Raha_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 16817079,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName:
        "Iltalehti.fi_raha_300x250|468x400|505x500|505x656_1_etusivu_(boksi,jättiboksi,pid.jättiboksi  Iltalehti_raha_Desktop - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Raha_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 16819050,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_raha_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 16817080,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_raha_300x250|468x400|505x500|505x656_2_etusivu_(boksi,jättiboksi,pid.jättiboksi - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 16817103,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_raha_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Raha_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 16817105,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_raha_300x250_2_(palstaboksi luetuimmat-noston alapuolella - rightBox2)",
      prebid: {
        active: !0,
        source: "Iltalehti_Raha_ROS_MediumRectangle",
      },
    },
  ],
  raha_desktop: {
    source: "raha_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  raha_desktop_article: {
    source: "raha_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 16817113,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },

        friendlyName:
          "Iltalehti.fi_raha_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Raha_ROS_MediumRectangle",
        },
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281352,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_raha_native_artikkeli_ala",
      },
    ],
  },
  raha_desktop_article_sponsored: {
    source: "raha_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-widerectangle-5",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  raha_desktop_wide_article: {
    source: "raha_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-widerectangle-5",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 16817113,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        friendlyName:
          "Iltalehti.fi_raha_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Raha_ROS_MediumRectangle",
        },
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281352,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_raha_native_artikkeli_ala",
      },
    ],
  },
  raha_desktop_wide_article_sponsored: {
    source: "raha_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-widerectangle-5",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  urheilu_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796931,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_urheilu_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Urheilu_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796924,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_urheilu_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796922,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_urheilu_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Urheilu_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796923,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_urheilu_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Urheilu_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796204,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_urheilu_300x250|468x400|505x500|505x656_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Urheilu_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291836,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_urheilu_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796927,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_urheilu_300x250_2_etusivu_(boksi) - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796925,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_urheilu_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Urheilu_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796926,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_urheilu_300x125|300x250_2_(palstaboksi - Facebook-noston alla - rightBox2)",
      prebid: {
        active: !0,
        source: "Iltalehti_Urheilu_ROS_MediumRectangle",
      },
    },
  ],
  urheilu_desktop: {
    source: "urheilu_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  urheilu_desktop_article: {
    source: "urheilu_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796929,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_urheilu_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Urheilu_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281588,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },

        friendlyName: "Iltalehti.fi_urheilu_native_artikkeli_ala",
      },
    ],
  },
  urheilu_desktop_article_sponsored: {
    source: "urheilu_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  urheilu_desktop_wide_article: {
    source: "urheilu_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796929,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_urheilu_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Urheilu_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281588,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },

        friendlyName: "Iltalehti.fi_urheilu_native_artikkeli_ala",
      },
    ],
  },
  urheilu_desktop_wide_article_sponsored: {
    source: "urheilu_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  viihde_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796958,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_viihde_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Viihde_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796953,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_viihde_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796950,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_viihde_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Viihde_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796952,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_viihde_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Viihde_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796222,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_viihde_300x250|468x400|505x500|505x656_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Viihde_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291838,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_viihde_outstream_desktop",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796954,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_viihde_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Viihde_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796955,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_viihde_300x125|300x250_2_(palstaboksi - Telkku-noston yläpuolella - rightBox2)",
      prebid: {
        active: !0,
        source: "Iltalehti_Viihde_ROS_MediumRectangle",
      },
    },
  ],
  viihde_desktop: {
    source: "viihde_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  viihde_desktop_article: {
    source: "viihde_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796956,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_viihde_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Viihde_ROS_MediumRectangle",
        },
      ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281597,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],

        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_viihde_native_artikkeli_ala",
      },
    ],
  },
  viihde_desktop_article_sponsored: {
    source: "viihde_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  viihde_desktop_wide_article: {
    source: "viihde_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796956,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_viihde_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Viihde_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281597,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],

        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_viihde_native_artikkeli_ala",
      },
    ],
  },
  viihde_desktop_wide_article_sponsored: {
    source: "viihde_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  saa_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796895,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_saa_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Saa_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796893,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_saa_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796175,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_saa_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Saa_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796182,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_saa_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Saa_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  saa_desktop: {
    source: "saa_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  iltv_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796832,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_il-tv_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_ILTV_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796834,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_il-tv_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796835,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_il-tv_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
    },
  ],
  iltv_desktop: {
    source: "iltv_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  iltv_desktop_article: {
    source: "iltv_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
    ],
  },
  iltv_desktop_article_sponsored: {
    source: "iltv_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  iltv_desktop_wide_article: {
    source: "iltv_desktop_wide",
    remove: ["almad-widerectangle-1", "almad-widerectangle-2"],
  },
  iltv_desktop_wide_article_sponsored: {
    source: "iltv_desktop_wide",
    remove: ["almad-widerectangle-1", "almad-widerectangle-2"],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  terveys_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796904,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_terveys_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Terveys_ROS_NordicParade",
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796897,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_terveys_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796183,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_terveys_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Terveys_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796184,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_terveys_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Terveys_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796190,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_terveys_300x250|468x400|505x500|505x656_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Terveys_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291834,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_terveys_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796899,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_terveys_300x250_etusivu_2_(boksi) - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796898,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 300],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_terveys_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Terveys_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796746,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_terveys_300x125|300x250_2_(palstaboksi2 - rightBox2)",
    },
  ],
  terveys_desktop: {
    source: "terveys_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  terveys_desktop_sponsored: {
    source: "terveys_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-widerectangle-2",
    ],
    add: [
      {
        divId: "almad-skyscraper-1",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  terveys_desktop_wide_sponsored: {
    source: "terveys_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-skyscraper-1",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  terveys_desktop_article: {
    source: "terveys_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796902,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_terveys_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Terveys_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281533,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_terveys_native_artikkeli_ala",
      },
    ],
  },
  terveys_desktop_article_sponsored: {
    source: "terveys_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  terveys_desktop_wide_article: {
    source: "terveys_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796902,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_terveys_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Terveys_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281533,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_terveys_native_artikkeli_ala",
      },
    ],
  },
  terveys_desktop_wide_article_sponsored: {
    source: "terveys_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  hyvaolo_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796842,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_hyvaolo_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Hyvaolo_ROS_NordicParade",
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796837,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_hyvaolo_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796139,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_hyvaolo_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796140,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_hyvaolo_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Hyvaolo_ROS_WideSkyscraper",
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796141,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_hyvaolo_300x250|468x400|505x500|505x656_1_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Hyvaolo_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291797,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_hyvaolo_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796146,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_hyvaolo_300x250|468x400|505x500|505x656_2_etusivu_(boksi,jättiboksi,pid.jättiboksi,A - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796838,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_hyvaolo_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796839,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_hyvaolo_300x125|300x250_2_(palstaboksi2 - rightBox2)",
    },
  ],
  hyvaolo_desktop: {
    source: "hyvaolo_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  hyvaolo_desktop_article: {
    source: "hyvaolo_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796841,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_hyvaolo_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Hyvaolo_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281603,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_hyvaolo_native_artikkeli_ala",
      },
    ],
  },
  hyvaolo_desktop_article_sponsored: {
    source: "hyvaolo_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  hyvaolo_desktop_wide_article: {
    source: "hyvaolo_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796841,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_hyvaolo_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Hyvaolo_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281603,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_hyvaolo_native_artikkeli_ala",
      },
    ],
  },
  hyvaolo_desktop_wide_article_sponsored: {
    source: "hyvaolo_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  tyylicom_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796912,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_tyyli.com_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Tyyli_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796906,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_tyyli.com_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796191,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_tyyli.com_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Tyyli_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796192,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_tyyli.com_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Tyyli_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796196,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },

      friendlyName:
        "Iltalehti.fi_tyyli.com_300x250|468x400|505x500|505x656_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291835,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_tyyli.com_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796909,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_tyyli.com_300x250_etusivu_2_(boksi) - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796907,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],

      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_tyyli.com_300x125|300x250_1_(palstaboksi luetuimmat yllä - oikea - rightBox1)",
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796908,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_tyyli.com_300x125|300x250_2_(palstaboksi kuukauden luetuimmat noston alla - rightBox2)",
      prebid: {
        active: !0,
        source: "Iltalehti_Tyyli_ROS_MediumRectangle",
      },
    },
  ],
  tyylicom_desktop: {
    source: "tyylicom_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  tyylicom_desktop_article: {
    source: "tyylicom_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796910,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_tyylicom_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Tyyli_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281554,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_tyylicom_native_artikkeli_ala",
      },
    ],
  },
  tyylicom_desktop_article_sponsored: {
    source: "tyylicom_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  tyylicom_desktop_wide_article: {
    source: "tyylicom_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796910,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_tyylicom_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Tyyli_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281554,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_tyylicom_native_artikkeli_ala",
      },
    ],
  },
  tyylicom_desktop_wide_article_sponsored: {
    source: "tyylicom_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  asuminen_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796750,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_asuminen_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Asuminen_ROS_NordicParade",
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796744,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_asuminen_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796742,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_asuminen_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796743,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_asuminen_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Asuminen_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796117,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_asuminen_300x250|468x400|505x500|505x656_1_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Asuminen_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291730,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_asuminen_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796747,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_asuminen_300x250_etusivu_2_(boksi - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796745,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],

      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_asuminen_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796746,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_asuminen_300x125|300x250_2_(palstaboksi Kuukauden luetuimmat-noston yläpuolella - rightBox2)",
    },
  ],
  asuminen_desktop: {
    source: "asuminen_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  asuminen_desktop_article: {
    source: "asuminen_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796749,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_asuminen_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Asuminen_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281413,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_asuminen_native_artikkeli_ala",
      },
    ],
  },
  asuminen_desktop_article_sponsored: {
    source: "asuminen_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  asuminen_desktop_wide_article: {
    source: "asuminen_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796749,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_asuminen_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Asuminen_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281413,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_asuminen_native_artikkeli_ala",
      },
    ],
  },
  asuminen_desktop_wide_article_sponsored: {
    source: "asuminen_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  perhe_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796873,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_perhe_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Perhe_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796865,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_perhe_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796154,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_perhe_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Perhe_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796155,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_perhe_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Perhe_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796161,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_perhe_300x250|468x400|505x500|505x656_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Perhe_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291819,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_perhe_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796869,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_perhe_300x250_etusivu_2_(boksi) - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796866,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_perhe_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Perhe_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796868,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_perhe_300x125|300x250_2_(palstaboksi - rightBox2)",
    },
  ],
  perhe_desktop: {
    source: "perhe_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  perhe_desktop_article: {
    source: "perhe_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796871,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_perhe_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Perhe_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281529,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_perhe_native_artikkeli_ala",
      },
    ],
  },
  perhe_desktop_article_sponsored: {
    source: "perhe_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  perhe_desktop_wide_article: {
    source: "perhe_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796871,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_perhe_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Perhe_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281529,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_perhe_native_artikkeli_ala",
      },
    ],
  },
  perhe_desktop_wide_article_sponsored: {
    source: "perhe_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  pippuri_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796882,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_pippuri_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Pippuri_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796875,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_pippuri_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796162,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_pippuri_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Pippuri_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796163,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_pippuri_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Pippuri_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796167,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_pippuri_300x250|468x400|505x500|505x656_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Pippuri_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291821,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_pippuri_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796878,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_pippuri_300x250_etusivu_2_(boksi) - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796876,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_pippuri_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796877,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName: "Iltalehti.fi_pippuri_300x250_1_(palstaboksi - rightBox2)",
    },
  ],
  pippuri_desktop: {
    source: "pippuri_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  pippuri_desktop_article: {
    source: "pippuri_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796880,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_pippuri_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Pippuri_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281531,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_pippuri_native_artikkeli_ala",
      },
    ],
  },
  pippuri_desktop_article_sponsored: {
    source: "pippuri_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  pippuri_desktop_wide_article: {
    source: "pippuri_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796880,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_pippuri_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Pippuri_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281531,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_pippuri_native_artikkeli_ala",
      },
    ],
  },
  pippuri_desktop_wide_article_sponsored: {
    source: "pippuri_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  matkailu_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796860,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_matkailu_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Matkailu_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796852,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_matkailu_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796147,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_matkailu_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796148,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_matkailu_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Matkailu_ROS_WideSkyscraper",
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796153,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_matkailu_300x250|468x400|505x500|505x656_etusivu_1_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291810,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_matkailu_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796855,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_matkailu_300x250_etusivu_2_(boksi) - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796853,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_matkailu_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Matkailu_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796854,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName: "Iltalehti.fi_matkailu_300x250_2_(palstaboksi - rightBox2)",
    },
  ],
  matkailu_desktop: {
    source: "matkailu_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  matkailu_desktop_article: {
    source: "matkailu_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796858,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_matkailu_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Matkailu_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281490,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],

        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_matkailu_native_artikkeli_ala",
      },
    ],
  },
  matkailu_desktop_article_sponsored: {
    source: "matkailu_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  matkailu_desktop_wide_article: {
    source: "matkailu_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796858,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_matkailu_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Matkailu_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281490,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],

        native: {
          templateSelector: fbOrSquareBlue,
        },
        friendlyName: "Iltalehti.fi_matkailu_native_artikkeli_ala",
      },
    ],
  },
  matkailu_desktop_wide_article_sponsored: {
    source: "matkailu_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  autot_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796760,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_autot_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Autot_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796753,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_autot_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796751,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_autot_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Autot_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796752,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_autot_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Autot_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796119,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_autot_300x250|468x400|505x500|505x656_1_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Autot_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291732,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_autot_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796754,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName: "Iltalehti.fi_autot_300x250_etusivu_2_(boksi - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796755,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_autot_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796756,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_autot_300x250_300x125_2(palstaboksi - rightBox2)",
    },
  ],
  autot_desktop: {
    source: "autot_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  autot_desktop_article: {
    source: "autot_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796759,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_autot_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Autot_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281439,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },

        friendlyName: "Iltalehti.fi_autot_native_artikkeli_ala",
      },
    ],
  },
  autot_desktop_article_sponsored: {
    source: "autot_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  autot_desktop_wide_article: {
    source: "autot_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796759,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_autot_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Autot_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281439,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },

        friendlyName: "Iltalehti.fi_autot_native_artikkeli_ala",
      },
    ],
  },
  autot_desktop_wide_article_sponsored: {
    source: "autot_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
    ],
  },
  digi_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796772,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_digi_980x120|980x400_(panorama,paraati) - topBanner",
      prebid: {
        active: !0,
        source: "Iltalehti_Digi_ROS_NordicParade",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
      ...ilParade,
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 9796764,
      sizes: [[1600, 1200]],
      friendlyName:
        "Iltalehti.fi_digi_1600x1200_(dynaaminen tapetti) - wallpaper",
      customNeeds: {
        adAvailable: () => wallpaperStyles(),
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796127,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_digi_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper1",
      prebid: {
        active: !0,
        source: "Iltalehti_Digi_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796128,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_digi_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper2",
      prebid: {
        active: !0,
        source: "Iltalehti_Digi_ROS_WideSkyscraper",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9796129,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [620, 891],
        [300, 250],
        [300, 300],
        [320, 320],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        templateSelector: fbOrSquareBlue,
      },
      friendlyName:
        "Iltalehti.fi_digi_300x250|468x400|505x500|505x656_1_etusivu_(boksi,jättiboksi,pid.jättiboksi,A4 boksi - middleBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Digi_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11291771,
      sizes: [[1, 1]],
      adType: "video",
      friendlyName: "Iltalehti.fi_digi_outstream_desktop",
    },
    {
      divId: "almad-widerectangle-2",
      placementId: 9796768,
      sizes: [
        [505, 500],
        [505, 656],
        [468, 400],
        [610, 877],
        [620, 891],
        [300, 250],
        [4, 2],
      ],
      friendlyName:
        "Iltalehti.fi_digi_300x250_(il-boksi, alustetaan etusivulla ei nytet L KYT - middleBox2)",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 9796766,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 600],
        [300, 431],
        [320, 431],
        [300, 300],
        [320, 320],
        [9, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      native: {
        template: "native_square_blue",
      },
      friendlyName:
        "Iltalehti.fi_digi_300x125|300x250_1_(palstaboksi - oikea - rightBox1)",
      prebid: {
        active: !0,
        source: "Iltalehti_Digi_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 9796773,
      sizes: [
        [300, 125],
        [300, 250],
        [300, 300],
        [140, 350],
        [160, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [320, 320],
        [9, 3],
      ],
      friendlyName:
        "Iltalehti.fi_digi_300x250_boksi_2_(ei kytss, tulee kyttn - rightBox2)",
    },
  ],
  digi_desktop: {
    source: "digi_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  digi_desktop_article: {
    source: "digi_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796770,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_digi_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Digi_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281470,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },

        friendlyName: "Iltalehti.fi_digi_native_artikkeli_ala",
      },
    ],
  },
  digi_desktop_article_sponsored: {
    source: "digi_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
      {
        divId: "almad-widerectangle-4",
        placementId: 9796770,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
        ],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_digi_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Digi_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
    ],
  },
  digi_desktop_wide_article: {
    source: "digi_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-widerectangle-4",
        placementId: 9796770,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_digi_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Digi_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
      {
        divId: "almad-mobile-parade-2",
        placementId: 18281470,
        sizes: [
          [300, 250],
          [300, 300],
          [320, 320],
          [4, 3],
          [1, 1],
        ],
        adType: ["banner", "native", "video"],
        native: {
          templateSelector: fbOrSquareBlue,
        },

        friendlyName: "Iltalehti.fi_digi_native_artikkeli_ala",
      },
    ],
  },
  digi_desktop_wide_article_sponsored: {
    source: "digi_desktop_wide",
    remove: [
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-outstream-1",
    ],
    add: [
      {
        divId: "almad-special-2",
        placementId: 13014570,
        sizes: [[1, 1]],
        lazyload: { disable: !0 },
        friendlyName: "Iltalehti.fi_sima",
      },
      {
        divId: "almad-widerectangle-4",
        placementId: 9796770,
        sizes: [
          [300, 250],
          [468, 400],
          [610, 877],
          [620, 891],
          [300, 300],
          [320, 320],
          [4, 3],
        ],
        native: {
          template: "sima_rectangle",
        },
        friendlyName:
          "Iltalehti.fi_digi_300x250|468x400_(artikkeliboksi,-jttiboksi)",
        prebid: {
          active: !0,
          source: "Iltalehti_Digi_ROS_MediumRectangle",
        },
        ...outstreamStyles
      },
    ],
  },
  pelit_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796863,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [1600, 1150],
        [2, 1],
      ],
      friendlyName:
        "Iltalehti.fi_pelit_980x120|980x400_(panorama,paraati) - topBanner",
      ...ilParade,
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9796861,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Iltalehti.fi_pelit_140x350|160x600|250x350|250x600_1_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper1",
    },
    {
      divId: "almad-skyscraper-2",
      placementId: 9796862,
      sizes: [
        [250, 600],
        [200, 600],
        [300, 600],
        [300, 431],
        [320, 431],
        [160, 600],
        [250, 350],
        [140, 350],
        [3, 2],
      ],
      friendlyName:
        "Iltalehti.fi_pelit_140x350|160x600|250x350|250x600_2_(suurtaulu,pidennetty,mega,pid.mega - ei hi - skyScraper2",
    },
  ],
  pelit_desktop: {
    source: "viihde_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  blogit_desktop_wide: [
    {
      divId: "almad-parade-1",
      placementId: 9796761,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [980, 120],
        [2, 1],
      ],
      friendlyName: "Iltalehti.fi_blogit_980x120|980x400_(panorama,paraati)",
    },
  ],
  blogit_desktop_wide_article: {
    source: "blogit_desktop_wide",
    remove: [],
  },
  blogit_desktop: {
    source: "blogit_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-skyscraper-2"],
  },
  blogit_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 9797639,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 250],
      ],
      friendlyName: "Iltalehti.fi_blogit__300x300_ylä_mobile",
      customNeeds: {
        adLoaded: () => {
          blogitCenterParade();
        },
      },
    },
  ],
};

export default tiviPlacements;
